import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const MAXDATE = () => {
  return (
    <CardSection id="MAXDATE" title="MAXDATE">
      <Paragraph>
        두 개 이상의 날짜를 비교해서 가장 늦은 날짜를 반환합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>MAXDATE(DATETIME_1, [DATETIME_2, ...])</Paragraph>
        <Ul>
          <Li>
            <b>DATETIME_1</b>은 첫 번째 날짜입니다.
          </Li>
          <Li>
            <b>DATETIME_2, ... [선택 사항]</b>은 추가 날짜입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>현재 지원 준비중인 함수입니다.</Paragraph>
        {/* <Img src="computeHour" /> */}
      </ListSection>

      {/* 
  <ListSection title="Notes on use">
    <Paragraph>
      <b>DATETIME</b>은 날짜/시간 객체, 날짜/시간 객체를 포함하는 열 또는 날짜/시간 객체를 반환하는 함수여야 합니다.
    </Paragraph>
    <Paragraph>
      반환하는 값의 범위는 0(오전 12시)부터 23(오후 11시)까지 입니다.
    </Paragraph>
  </ListSection>
  */}
    </CardSection>
  );
};
